import moment from 'moment';
import { freezeBody, unfreezeBody } from './freezeScroll';
import debounce from 'lodash/debounce';
import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from "gsap/all";
require('animation.gsap');


/* GET DMENSIONS */

function getBrowserDimensions(reqDimension) {
    switch (reqDimension) {
        case 'height':
            return window.innerHeight || document.documentElement.clientHeight;
            break;
        case 'width':
            return window.innerWidth || document.documentElement.clientWidth;
            break;
        default:
    }
}

// returns object with viewport properties
const getViewportProperties = () => {
    const properties = {
        "width": window.innerWidth,
        "height": window.innerHeight,
        "orientation": window.innerWidth < window.innerHeight ? 'portrait' : 'landscape'
    }
    return properties;
}




/* WEEKDAY NOTICES */

// get weekday notices
const weekdayNotices = document.querySelectorAll('.top-bar__notice--weekday');
if (weekdayNotices) {
    // get today's date
    const todaysDate = moment();
    // get todays weekday
    const todaysWeekday = todaysDate.format("dddd").toLowerCase();
    // make array from notices and iterate through it
    const weekdayNoticeArray = Array.from(weekdayNotices);
    weekdayNoticeArray.forEach(element => {
        // get item and its day
        const thisNotice = element;
        const thisNoticeDay = thisNotice.dataset.weekday;
        // if item weekday is same as today
        if (thisNoticeDay == todaysWeekday) {
            // add formatted date to notice
            thisNotice.innerHTML = todaysDate.format("dddd, MMMM Do, YYYY") + ' | ' + thisNotice.innerHTML;
            // reveal notice
            thisNotice.classList.add('top-bar__notice--active');
        }
    });
}




/* SCROLL FUNCTIONS */

const header = document.getElementById('header');
const topBar = document.getElementById('top-bar-wrapper');
const headerCta = document.getElementById('header__cta');
const homehero = document.getElementById('home__hero');
const subnavHero = document.querySelector('.subnav__hero');
let scrollY = 0;

window.addEventListener('scroll', function (e) {

    // get scroll distance
    scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
    // console.log(`scrollY:${scrollY}, topBar.clientHeight:${topBar.clientHeight}`);

    // make header fixed when scrolling past it
    if ( ( topBar && scrollY > topBar.clientHeight ) || ( topBar && scrollY == 0 && document.body.classList.contains('open-mobile-nav'))) {
        // set header top position
        header.style.top = '-'+topBar.clientHeight+'px';
        // set body padding top to whole header height
        document.body.style.paddingTop = header.clientHeight+'px';
        // make it fixed
        document.body.classList.add('body--fixed-header');
    } else {
        // unfix header
        document.body.classList.remove('body--fixed-header');
        // creal header and body styles
        header.style.top = '';
        document.body.style.paddingTop = '';
    }

    // header subnav fix
    if (subnavHero && topBar) {
        // get scroll distance
        scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
        // if scroll past subnav
        if (scrollY > (topBar.clientHeight + subnavHero.clientHeight)) {
            document.body.classList.add('body--fixed-subnav');
        } else {
            document.body.classList.remove('body--fixed-subnav');
        }
    }

});




/* HEADER TICKETS CTA */
/*
if( !homehero && headerCta ){
    headerCta.classList.add('box-cta-filled');
}
*/




/* MENU TOGGLE */

const menuToggle = document.querySelector('.header__menu-toggle');
const headerNavContainer = document.querySelector('.header__nav-container');
const headerNavContainerOuter = document.querySelector('.header__nav-container-outer');

if (headerNavContainer) {
    headerNavContainer.addEventListener('click', () => {
        closeMenu();
    });
}

if (headerNavContainerOuter) {
    headerNavContainerOuter.addEventListener('click', (event) => {
        event.stopPropagation();
    });
}

function openMenu() {
    headerNavContainer.classList.add('header__nav-container--active');
    menuToggle.classList.add('header__menu-toggle--active');
    header.classList.add('header--mobile-nav-open');

    document.querySelector('html').classList.add('open-mobile-nav');
    document.body.classList.add('open-mobile-nav');

    freezeBody();

    setTimeout(function () {
        headerNavContainer.classList.add('header__nav-container--open');
    }, 10);
};

function closeMenu() {
    headerNavContainer.classList.remove('header__nav-container--open');
    menuToggle.classList.remove('header__menu-toggle--active');
    header.classList.remove('header--mobile-nav-open');

    document.querySelector('html').classList.remove('open-mobile-nav');
    document.body.classList.remove('open-mobile-nav');

    unfreezeBody();

    setTimeout(function () {
        headerNavContainer.classList.remove('header__nav-container--active');
    }, 350);
};

if (header && menuToggle && headerNavContainer) {
    menuToggle.addEventListener('click', function (event) {
        event.preventDefault();
        let isOpen = menuToggle.classList.contains('header__menu-toggle--active');
        isOpen ? closeMenu() : openMenu();
    });
}

const removeMobileNavIfDesktop = () => {
    if (getBrowserDimensions('width') > 767 && document.body.classList.contains('open-mobile-nav')) {
        document.body.removeAttribute('style');
    }
}




/* SCRSET BG IMAGES */

// REFERENCE: small-thumbnail:640, thumbnail:812, medium:1366, large:1920, full:original size

let bgSrcset = document.querySelectorAll('.bg-srcset');
const setBgSrcset = () => {
    // console.log('setBgSrcset()');
    if (bgSrcset) {
        // get window width
        const browserWidth = getBrowserDimensions('width');
        // get all bgs
        const bgSrcsetArray = Array.from(bgSrcset);
        // console.log(bgSrcsetArray.length);
        bgSrcsetArray.forEach(element => {
            const thisBg = element;
            let image;
            // get image depending on size
            if (browserWidth > 0 && browserWidth < 641) {
                image = thisBg.dataset.srcSmall;
            } else if (browserWidth >= 640 && browserWidth < 813) {
                image = thisBg.dataset.srcThumbnail;
            } else if (browserWidth >= 813 && browserWidth < 1367) {
                image = thisBg.dataset.srcMedium;
            } else if (browserWidth >= 1367 && browserWidth < 1921) {
                image = thisBg.dataset.srcLarge;
            } else {
                image = thisBg.dataset.srcFull;
            }
            // set image
            thisBg.style.backgroundImage = "url(" + image + ")";
        });
    }
}




/* SEARCH */

// toggle search overlay
const searchOverlay = document.getElementById('search-overlay');
const topBarSearchToggle = document.getElementById('top-bar__search-toggle');
const searchOverlayClose = document.getElementById('search-overlay__close');
const toggleSearch = () => {
    searchOverlay.classList.toggle('search-overlay--active');
}
if (searchOverlay && topBarSearchToggle) {
    topBarSearchToggle.addEventListener('click', event => {
        event.preventDefault();
        toggleSearch();
    });
}
if (searchOverlay && searchOverlayClose) {
    searchOverlayClose.addEventListener('click', event => {
        event.preventDefault();
        toggleSearch();
    });
}

// search form submit
const searchform = document.getElementById('searchform');
const searchInput = document.getElementById('s');
if (searchform && searchInput) {
    searchform.addEventListener('submit', event => {
        event.preventDefault();
        window.open('https://info.nmajh.org/search.aspx?q=' + searchInput.value);
        toggleSearch();
    });
}




/* EXPANDABLE SECTIONS */

const expandableSection = document.querySelectorAll('.expandable-section__header');
if (expandableSection) {
    const expandableSectionArray = Array.from(expandableSection);
    expandableSectionArray.forEach(element => {
        element.addEventListener('click', (event) => {
            const elementParent = element.parentNode;
            toggleExpandableSections(elementParent);
        });
    });
    const toggleExpandableSections = (item) => {
        // get clicked item index
        const clickedIndex = item.dataset.index;
        // get section parent
        const sectionParent = item.parentNode;
        if (sectionParent) {
            // get section parent items
            const sectionItems = sectionParent.querySelectorAll('.expandable-section');
            if (sectionItems) {
                // make all others inactive
                const sectionItemsArray = Array.from(sectionItems);
                sectionItemsArray.forEach(element => {
                    if (clickedIndex != element.dataset.index) {
                        element.classList.remove('expandable-section--active');
                    }
                });
            }
        }
        // toggle clicked item active status
        item.classList.toggle('expandable-section--active');
    }
}




/* HERO PARALLAX */

const heroImageWrapper = document.querySelector('.hero-image__wrapper');
let heroImageController = null;
if (heroImageWrapper) {

    const heroOrientation = heroImageWrapper.dataset.orientation;

    const startPercentage = heroOrientation == 'horizontal' ? '-10%' : '0%';
    const endPercentage = '20%';

    heroImageController = new ScrollMagic.Controller();
    // intro in
    new ScrollMagic.Scene({
        duration: '100%',
        triggerElement: '#hero-image__wrapper',
        triggerHook: 0,
        offset: 0
    })
        .setTween(
            TweenMax.fromTo('.hero-image', 1, { y: startPercentage }, { y: endPercentage })
        )
        .addTo(heroImageController);
}




// ON LOAD

setBgSrcset();




// ON RESIZE

window.addEventListener('resize', debounce(() => {
    setBgSrcset();
    removeMobileNavIfDesktop();
}, 150));

export {
    getBrowserDimensions,
    getViewportProperties,
    closeMenu,
    setBgSrcset
}


// Core Exhibition - Virtual Tour Tips
// toggle overlay
const virtualTourOverlay = document.getElementById('virtualTour-overlay');
const virtualTourOverlayToggle = document.getElementById('virtualTour-toggle');
const virtualTourOverlayClose = document.getElementById('virtualTour-overlay__close');
const toggleTourTips = () => {
    document.body.classList.toggle('overlay--active');
    virtualTourOverlay.classList.toggle('virtualTour-overlay--active');
    
}
if (virtualTourOverlay && virtualTourOverlayToggle) {
    virtualTourOverlayToggle.addEventListener('click', event => {
        event.preventDefault();
        toggleTourTips();
    });
}
if (virtualTourOverlay && virtualTourOverlayClose) {
    virtualTourOverlayClose.addEventListener('click', event => {
        event.preventDefault();
        toggleTourTips();
    });
}


// Accordion Gallery
/*
const sliderHeros = document.querySelectorAll('.slider-hero');
sliderHeros.forEach((sliderHero,index) => {
    sliderHero.addEventListener('click',()=>{
        sliderHero.classList.toggle('hero--active');
    });

});
*/

// Accordion item click
const accordionItems = document.querySelectorAll('.accordion-gallery__item');
accordionItems.forEach((accordionItem,index) => {
    accordionItem.addEventListener('click', event=>{
        event.stopPropagation();
        // make hero active
        // const parentHero = accordionItem.closest('#hero');
        // parentHero.classList.add('hero--active');
        const parentAccordion = accordionItem.closest('.accordion-gallery');
        stopAccordionAutoplay(parentAccordion);
        parentAccordion.setAttribute('data-gallery-index',event.currentTarget.dataset.index);
        const parentGallery = accordionItem.parentNode;
        manageGalleryItemStatus(parentAccordion,index);
    });
});

const manageGalleryItemStatus = (accordion,index) => {
    const galleryItems = accordion.querySelectorAll('.accordion-gallery__item');
    galleryItems.forEach((galleryItem,gindex)=>{
        if( index == gindex ){
            galleryItem.classList.add('accordion-gallery__item--active');
        } else {
            galleryItem.classList.remove('accordion-gallery__item--active');
        }
    });     
}

const setAccordionIndex = (accordion) => {
    // get count and current index
    let index = Number(accordion.dataset.galleryIndex);
    const count = Number(accordion.dataset.galleryCount);
    index = index < count - 1 ? index + 1 : 0;
    // update accordion with new index
    accordion.setAttribute('data-gallery-index',index);
    // set accordion items status
    manageGalleryItemStatus(accordion,index);
}

const stopAccordionAutoplay = (accordion) => {
    clearInterval(accordionIntervals[accordion.id]);
}

const accordionSpeed = 4000;
let accordionIntervals = {};
const autoplayAccordion = (accordion) => {
    accordionIntervals[accordion.id] = setInterval(()=>{
        setAccordionIndex(accordion);
    },accordionSpeed);
}

const accordionGalleries = document.querySelectorAll('.accordion-gallery');
accordionGalleries.forEach((accordionGallery,index) => {
    autoplayAccordion(accordionGallery);
});
